import { CompanyGradeExpirationCode } from '#data/CompanyGradeExpirationCode.enum';
import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';

export const gradeMissingMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/CompanyGrade$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'CompanyGrade',
        statusCode: ControllerStatus.CHECK_REJECTED,
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2023-09-26T00:00:00.000Z',
          controlData: {
            companyId: '113',
            expirationCode: CompanyGradeExpirationCode.NO_REFRESH_DATE,
            rejectCode: 'MISSING_GRADE',
          },
        },
      } satisfies ControllerDetails,
    },
  },
];
